import { array, boolean, object, string } from 'yup';

export const inviteSchema = object().shape({
  invitedUsers: array()
    .of(string().email('Please enter valid email addresses'))
    .min(1, 'Please add at least one user'),
  role: string().required(),
  downloadAccess: boolean().required('Please select one option'),
});
